import React, { Component } from "react";
import { withRouterUtilities } from "../util/withRouterUtilities";
import CenteredPaper from "../layouts/CenteredPaper";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import ChoiceButtons from "../molecules/ChoiceButtons";
import Titles from "../molecules/Titles";
import UswfList from "../molecules/UswfList";
import { Calculator } from "../molecules/Calculator";
import ILearn from "../molecules/ILearn";

class PreapprovalWhatToDoNextPage extends Component {
  render() {
    const content = contentMap.PreapprovalWhatToDoNextPage;
    const navigationsAway = customNavigationMap.PreapprovalWhatToDoNextPage;

    return (
      <div className="page-wrapper">
        <ILearn content={content}>
          <CenteredPaper>
            <Titles content={content}>
              <Calculator type="MortgageQualifier" />
              <UswfList content={content} />
            </Titles>
            <ChoiceButtons
              content={content}
              navigationsAway={navigationsAway}
              onSecondaryClick={() =>
                (window.location.href = "https://clear.loans/contact")
              }
            />
          </CenteredPaper>
        </ILearn>
      </div>
    );
  }
}

export default withRouterUtilities(PreapprovalWhatToDoNextPage);
